<template>
    <div class="reset-password-view gutter frame">
        <h1>Let's reset your password</h1>
        <vuetiful-form class="reset-password-form" :form="form" @success="redirect">
            <label>
                <span>Email</span>
                <error :error="form.validator.getError('email')"></error>
                <input v-model="form.email" type="email">
            </label>
            <label>
                <span>New Password</span>
                <error :error="form.validator.getError('password')"></error>
                <input v-model="form.password" type="password">
            </label>
            <label>
                <span>Confirm Password</span>
                <error :error="form.validator.getError('passwordConfirm')"></error>
                <input v-model="form.passwordConfirm" type="password">
            </label>
        </vuetiful-form>
    </div>
</template>

<script>
    import VuetifulForm      from 'vuetiful-forms/src/components/VuetifulForm'
    import Error             from 'vuetiful-forms/src/components/Error'
    import ResetPasswordForm from "../../Forms/ResetPasswordForm";
    import View              from '../../../../App/Views/BaseView';
    import FormWithLoader    from "../../../../App/Views/Components/FormWithLoader";

    export default {
        name      : "ForgotPasswordForm",
        components: { VuetifulForm ,Error},
        extends   : View,

        data() {
            return {
                form: new ResetPasswordForm(this.getRouteParameter('token')),
            }
        },

        methods: {
            redirect() {
                window.location.href = '/';
            }
        }
    }
</script>

<style scoped>

</style>
